
//  console.log("Development Build")

console.log("Sandbox Build")


export const environment = {
    production: true,
    userApiUrl: 'https://sandboxuserapi.credbull.in/',
    walletApiUrl: 'https://sandboxwalletapi.credbull.in/',
    spotApiUrl: 'https://sandboxspotapi.credbull.in/',
    launchpadApiUrl: 'https://sandboxbotapi.credbull.in/',
    botApiUrl: 'https://sandboxbotapi.credbull.in/',
    gridBotApiUrl: 'https://sandboxgridapi.credbull.in/',
    arbitrageBotApiUrl: 'https://arbitrageapi.credbull.in/',
    adminTradebotApiUrl: 'https://sandboxvwinbot.credbull.in/',
    adminTradebotDownSideApiUrl: 'https://hanumanbot.credbull.in/',
    hanumanUpsideApiUrl: 'https://hanumanbotupside.credbull.in/',
    guruBotApiUrl: 'https://gurubot.credbull.in/',
};

